import React from 'react';
import { Link } from 'react-router-dom';
import { useI18n } from '../i18n/I18nContext';

function Footer() {
  const { t, localizedPath } = useI18n();

  return (
    <footer className="bg-zinc-900/30 backdrop-blur-sm border-t border-zinc-800 py-12">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-8 mb-8">
          <div>
            <img
              src="/impresstars-logo.png"
              alt="Impresstars Logo"
              className="h-10 sm:h-12 md:h-16 lg:h-20 w-auto select-none max-w-full brightness-0 invert"
              loading="eager"
              aria-label="Impresstars"
            />
            <p className="text-gray-400 text-sm">
              {t.footer.tagline}
            </p>
          </div>
          <div>
            <h4 className="text-white font-semibold mb-4">{t.footer.quickLinks}</h4>
            <ul className="space-y-2">
              <li><Link to={localizedPath('/#services')} className="text-gray-400 hover:text-[#FDCB12] transition">{t.nav.services}</Link></li>
              <li><Link to={localizedPath('/#star-models')} className="text-gray-400 hover:text-[#FDCB12] transition">{t.footer.starModels}</Link></li>
              <li><Link to={localizedPath('/partners')} className="text-gray-400 hover:text-[#FDCB12] transition">{t.nav.partners}</Link></li>
              <li><Link to={localizedPath('/#about')} className="text-gray-400 hover:text-[#FDCB12] transition">{t.nav.about}</Link></li>
              <li><Link to={localizedPath('/#contact')} className="text-gray-400 hover:text-[#FDCB12] transition">{t.nav.contact}</Link></li>
            </ul>
          </div>
          <div>
            <h4 className="text-white font-semibold mb-4">{t.footer.starModels}</h4>
            <ul className="space-y-2">
              <li>
                <a
                  href="https://cleaningedge.ca"
                  target="_blank"
                  rel="noopener noreferrer nofollow"
                  className="text-gray-400 hover:text-[#FDCB12] transition"
                >
                  Cleaning EDGE
                </a>
              </li>
              <li>
                <a
                  href="https://ozean.ca"
                  target="_blank"
                  rel="noopener noreferrer nofollow"
                  className="text-gray-400 hover:text-[#FDCB12] transition"
                >
                  Ozean
                </a>
              </li>
            </ul>
          </div>
          <div>
            <h4 className="text-white font-semibold mb-4">{t.footer.legal}</h4>
            <ul className="space-y-2">
              <li><Link to={localizedPath('/terms-conditions')} className="text-gray-400 hover:text-[#FDCB12] transition">{t.footer.termsConditions}</Link></li>
              <li><Link to={localizedPath('/privacy-policy')} className="text-gray-400 hover:text-[#FDCB12] transition">{t.footer.privacyPolicy}</Link></li>
            </ul>
          </div>
          <div>
            <h4 className="text-white font-semibold mb-4">{t.footer.contactTitle}</h4>
            <ul className="space-y-2 text-gray-400">
              <li>{t.footer.city}</li>
              <li>{t.footer.country}</li>
              <li>
                <a
                  href="mailto:info@impresstars.com"
                  className="font-semibold text-[#FDCB12] hover:text-[#FF5500] transition"
                >
                  info@impresstars.com
                </a>
              </li>
            </ul>
          </div>
        </div>
        <div className="border-t border-zinc-800 pt-8 text-center text-gray-400 text-sm">
          <p className="mb-2">&copy; {new Date().getFullYear()} {t.footer.rightsReserved}</p>
          <p className="text-xs text-gray-500">{t.footer.notALawFirm}</p>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
